var path = '/mnt/data/www/mashservisnn/vhost/frontend/src/app/modules/home/home.html';
var html = "<div style=overflow:hidden> <header class=header id=header> <div class=container> <div class=\"animated fadeInDown delay-07s\"> <h1>+7 (950) 620-37-73</h1> <h5>Качественный ремонт стиральных машин и холодильников.</h5> </div> <ul class=\"we-create animated fadeInUp delay-1s\"> <li></li> </ul> <a class=\"link animated fadeInUp delay-1s call\" href=#>Заказать звонок</a> </div> </header> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/home.html
// module id = 59
// module chunks = 0